import styled from 'styled-components'

const ActionsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
`

export default ActionsContainer
